$(function () {
    const base_url = $("#base_url").val();

    $('.preview-image').on('click', function (e) {
        e.preventDefault();
        var imageUrl = $(this).data('image');
        $.fancybox.open({
            src: imageUrl,
            type: 'image',
            btnTpl: {
                rotate: '<button data-fancybox-rotate class="fancybox-button fancybox-button--rotate" title="{{ROTATE}}">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 22h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1zM9 6h6v10H9V6z"/></svg>' +
                    '</button>',
                flipX: '<button data-fancybox-flipx class="fancybox-button fancybox-button--flipx" title="{{FLIP_X}}">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"/></svg>' +
                    '</button>',
                flipY: '<button data-fancybox-flipy class="fancybox-button fancybox-button--flipy" title="{{FLIP_Y}}">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 15h2v2H3v-2zm0-4h2v2H3v-2zm0-4h2v2H3V7zm0-4h2v2H3V3zm4 0h2v2H7V3zm4 0h2v2h-2V3zm4 0h2v2h-2V3zm4 0h2v2h-2V3zm0 4h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2H7v-2z"/></svg>' +
                    '</button>'
            },
            infobar: true,
            toolbar: true,
            arrows: true,
            buttons: [
                "zoom",
                "rotate",
                "flipX",
                "flipY",
                "slideShow",
                "fullScreen",
                "thumbs",
                "close"
            ],
            // Custom button grouping
            buttonToolbar: {
                left: ["infobar"],
                middle: [
                    "zoomIn",
                    "zoomOut",
                    "toggle1to1",
                    "rotate",
                    "flipX",
                    "flipY",
                ],
                right: ["slideShow", "thumbs", "close"],
            },
            // Custom button actions
            clickContent: function (current, event) {
                return current.type === "image" ? "toggleControls" : false;
            },
            clickSlide: "close",
            dblclickContent: function (current, event) {
                return current.type === "image" ? "zoom" : false;
            },
            mobile: {
                clickContent: function (current, event) {
                    return current.type === "image" ? "toggleControls" : false;
                },
                clickSlide: function (current, event) {
                    return current.type === "image" ? "toggleControls" : "close";
                },
            },
        });
    });

    $.fn.isJson = function (data) {
        try {
            JSON.parse(data);
            return true;
        } catch (error) {
            return false;
        }
    };
    $.fn.globalVariables = function (key) {
        let rawValue = $(`.global-variable[data-name="${key}"]`).val();
        if ($().isJson(rawValue)) {
            return JSON.parse(rawValue);
        }
        return rawValue;
    };

    $.fn.validateEmail = function (mail) {
        if (mail) {
            let emailRegEx = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            return emailRegEx.test(mail);
        } else {
            return false;
        }
    };

    $.fn.validateTel = function (tel) {
        if (tel) {
            let tel_pattern = /^\(?(\d{2,3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})$/;
            return tel_pattern.test(tel);
        } else {
            return false;
        }
    };

    $.fn.validate_form = async function (form) {
        let check = 0;
        let validate_focus = null;
        let validate_array = [];

        form.find(".invalid-feedback").remove();
        form.find(".validate").removeClass("validate-error");

        form.find(".validate").each(function () {
            validate_array.push($(this));
        });

        for (const loop_await of validate_array) {
            if (loop_await.attr("validate-type") == "tel") {
                if ($.fn.validateTel(loop_await.val()) == false) {
                    loop_await.addClass("validate-error");
                    loop_await.after(
                        '<div class="invalid-feedback d-block text-end">' +
                        loop_await.attr("valid-feedback") +
                        "</div>"
                    );
                    check++;
                }
            } else if (loop_await.attr("validate-type") == "email") {
                if ($.fn.validateEmail(loop_await.val()) == false) {
                    loop_await.addClass("validate-error");
                    loop_await.after(
                        '<div class="invalid-feedback d-block text-end">' +
                        loop_await.attr("valid-feedback") +
                        "</div>"
                    );
                    check++;
                }
            } else if (loop_await.attr("validate-type") == "select") {
                loop_await.addClass("validate-error");
                loop_await.after(
                    '<div class="invalid-feedback d-block text-end">' +
                    loop_await.attr("valid-feedback") +
                    "</div>"
                );
                check++;
            } else if (loop_await.attr("validate-type") == "password") {
                if (loop_await.val().trim() == "") {
                    loop_await.addClass("validate-error");
                    loop_await
                        .closest("div")
                        .after(
                            '<div class="invalid-feedback d-block text-end">' +
                            loop_await.attr("valid-feedback") +
                            "</div>"
                        );
                    check++;
                }
            } else if (loop_await.attr("validate-type") == "tax") {
                if (
                    loop_await.val().trim() == "" ||
                    loop_await.val().length < 13
                ) {
                    loop_await.addClass("validate-error");
                    loop_await.after(
                        '<div class="invalid-feedback d-block text-end">' +
                        loop_await.attr("valid-feedback") +
                        "</div>"
                    );
                    check++;
                }
            } else {
                if (loop_await.val().trim() == "") {
                    loop_await.addClass("validate-error");
                    loop_await.after(
                        '<div class="invalid-feedback d-block text-end">' +
                        loop_await.attr("valid-feedback") +
                        "</div>"
                    );
                    check++;
                }
            }

            if (!validate_focus && check > 0) {
                validate_focus = loop_await;
            }
        }

        if (validate_focus) {
            validate_focus.focus();
        }

        let data_return = {
            check: check,
        };

        return data_return;
    };

    $(document).on("input", '[data-input="number"]', function (e) {
        this.value = this.value.replace(/[^0-9\d]/g, "");
    });

    $.fn.digits = function (number) {
        var parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    };

    $.fn.toastEvent = function (config = {}) {
        $.toast({
            heading: config.heading ? config.heading : $("#alert").val(),
            icon: config.icon ? config.icon : "info",
            text: config.text ? config.text : "",
            position: config.position ? config.position : "bottom-right",
            stack: 2,
            showHideTransition: "slide",
            hideAfter: config.time ? config.time : 1500,
        });
    };

    $.fn.setLoading = function (type) {
        if (type == "start") {
            Swal.fire({
                title: "กรุณารอสักครู่...",
                html: "",
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        } else {
            Swal.close();
        }
    };

    function restrictToNumberOnly(e) {
        var keyCode = e.which ? e.which : e.keyCode;
        if (!(keyCode >= 48 && keyCode <= 57)) {
            e.preventDefault();
        }
    }
    $(".input-number").on("keypress", restrictToNumberOnly);

    function checkCid(e) {
        var length = e.target.value.length;
        if (length >= 13) {
            e.preventDefault();
        }
    }
    $('[data-input="cid"]').on("keypress", checkCid);

    function checkTel(e) {
        var length = e.target.value.length;
        if (length >= 10) {
            e.preventDefault();
        }
    }
    $('[data-input="tel"]').on("keypress", checkTel);

    $.fn.datelang = (date, lang) => {
        switch (lang) {
            case "th":
                date = date.split(" to ");
                if (date.length > 1) {
                    date[0] = new Date(
                        new Date(date[0]).setFullYear(
                            new Date(date[0]).getFullYear() - 543
                        )
                    )
                        .toISOString()
                        .slice(0, 10);
                    date[1] = new Date(
                        new Date(date[1]).setFullYear(
                            new Date(date[1]).getFullYear() - 543
                        )
                    )
                        .toISOString()
                        .slice(0, 10);
                    date = date.join(" to ");
                } else {
                    date = new Date(
                        new Date(date).setFullYear(
                            new Date(date).getFullYear() - 543
                        )
                    )
                        .toISOString()
                        .slice(0, 10);
                }
                break;
            case "eng":
            case "laos":
                break;
            default:
                break;
        }
        return date;
    };

    $.fn.getage = (dateOfBirth, type) => {
        if (dateOfBirth) {
            const dateParts = dateOfBirth.split("/");
            const outputDate = new Date(
                dateParts[2],
                dateParts[1] - 1,
                dateParts[0]
            );
            const birthDate = new Date(outputDate);
            const today = new Date();
            let birthYear = birthDate.getFullYear();
            if ($("#textlang").val() == "th") {
                birthYear = birthYear - 543;
            }
            let age = today.getFullYear() - birthYear;
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            // Calculate month
            let month = today.getMonth() - birthDate.getMonth();
            if (
                month < 0 ||
                (month === 0 && today.getDate() < birthDate.getDate())
            ) {
                month = 12 + month;
            }

            // Calculate day
            let day = today.getDate() - birthDate.getDate();
            if (day < 0) {
                const lastMonth = new Date(
                    today.getFullYear(),
                    today.getMonth() - 1,
                    0
                );
                day = lastMonth.getDate() + day;
            }

            if (type == 1) {
                return `${age} ปี, ${month} เดือน, ${day} วัน`;
            } else {
                return { age: age, month: month, day: day };
            }
        } else {
            return "";
        }
    };

    $.fn.generateRandomString = (length = 10) => {
        const characters = "0123456789";
        const charactersLength = characters.length;
        let randomString = "";
        for (let i = 0; i < length; i++) {
            randomString +=
                characters[Math.floor(Math.random() * charactersLength)];
        }
        return randomString;
    };

    $.fn.get_bc_hn = () => {
        return "1" + $.fn.generateRandomString(9);
    };

    $.fn.get_mbc_hn = () => {
        const currentYear = new Date().getFullYear().toString().substr(-2);
        const currentMonth = new Date().getMonth() + 1;
        const randomString = $.fn.generateRandomString(6);
        return `${currentYear}${currentMonth
            .toString()
            .padStart(2, "0")}${randomString}`;
    };

    $.fn.setFileimage = (form, elements) => {
        if (Array.isArray(elements)) {
            elements.forEach(function (element, key) {
                const src = element.getAttribute("src");
                if (
                    src.startsWith("data:") &&
                    src != "https://mcscloud.co/assets/img/hm_pro.png"
                ) {
                    const parts = src.split(",");
                    const contentType = parts[0].split(":")[1];
                    const raw = window.atob(parts[1]);
                    const rawLength = raw.length;
                    const uInt8Array = new Uint8Array(rawLength);
                    for (let i = 0; i < rawLength; ++i) {
                        uInt8Array[i] = raw.charCodeAt(i);
                    }
                    const file = new File([uInt8Array], `img_${key}.png`, {
                        type: contentType,
                    });
                    form.append("file[]", file);
                }
            });
        } else {
            const src = elements.getAttribute("src");
            if (
                src.startsWith("data:") &&
                src != "https://mcscloud.co/assets/img/hm_pro.png"
            ) {
                const parts = src.split(",");
                const contentType = parts[0].split(":")[1];
                const raw = window.atob(parts[1]);
                const rawLength = raw.length;
                const uInt8Array = new Uint8Array(rawLength);
                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                const file = new File([uInt8Array], `img.png`, {
                    type: contentType,
                });
                form.append("file", file);
            }
        }
    };

    $.fn.addCsrf = (form) => {
        form.append([$(".csrf-page").attr("name")], $(".csrf-page").val());
    };


    $.fn.SweetAlertSuccess = function (obj) {
        return Swal.fire({
            icon: "success",
            title: obj.title ? obj.title : 'แจ้งเตือน',
            text: obj.text ? obj.text : 'สำเร็จ',
            confirmButtonText: obj.confirmText ? obj.confirmText : "ตกลง",
            customClass: {
                confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
        }).then(res => {
            if (obj.redirectUrl) {
                window.location = obj.redirectUrl;
            }
        });
    };

    $.fn.SweetAlertError = function (obj) {
        return Swal.fire({
            icon: "error",
            title: obj.title ? obj.title : 'เกิดข้อผิดพลาด',
            text: obj.text ? obj.text : 'กรุณาทำรายการใหม่อีกครั้ง',
            confirmButtonText: obj.confirmText ? obj.confirmText : "ตกลง",
            customClass: {
                confirmButton: "btn btn-danger",
            },
            buttonsStyling: false,
        }); SweetconFirm
    };

    $.fn.SweetconFirm = function (obj) {
        return Swal.fire({
            icon: obj.icon ? obj.icon : "warning",
            title: obj.title ? obj.title : "แจ้งเตือน",
            html: obj.html ? obj.html : "",
            text: obj.html ? undefined : (obj.text ? obj.text : "ยืนยันการทำรายการ"),
            width: obj.width ? obj.width : undefined,
            confirmButtonText: obj.confirmText ? obj.confirmText : "ยืนยัน",
            cancelButtonText: obj.cancelText ? obj.cancelText : "ยกเลิก",
            showCancelButton: typeof obj.showCancelButton !== 'undefined' ? obj.showCancelButton : true,
            showConfirmButton: typeof obj.showConfirmButton !== 'undefined' ? obj.showConfirmButton : true,
            customClass: {
                confirmButton: obj.color ? "btn btn-" + obj.color : "btn btn-danger",
                cancelButton: "btn btn-secondary"
            },
            buttonsStyling: false,
        });
    };

    $(document).on("click", ".preview-image", function (e) {
        e.preventDefault();
        var src = $(this).attr("src");
        $("#image-preview").attr("src", src);
        $(".btn-preview-external").attr("href", src);
        $("#modal_preview").modal("show");
    });

    $.fn.setNumberbill = async function (type, number) {
        let before = "";
        let dataNumber = "";
        let max = 6;
        let index = number.length;
        var d = new Date(),
            month = "" + (d.getMonth() + 1),
            year = d.getFullYear();
        if (month <= 9) {
            month = "0" + month;
        }

        if (type == 2) {
            max = 4;
            before = year + "" + month;
        } else if (type == 3) {
            before = year;
        }

        let more = max - index;
        for (let i = 0; i < more; i++) {
            dataNumber += "0";
        }

        return before + "" + dataNumber + "" + number;
    };

    $.fn.getage_register = (dateOfBirth) => {
        var thaiBuddhistParts = dateOfBirth.split("/");
        var thaiBuddhistYear = parseInt(thaiBuddhistParts[2]);
        var gregorianYear = thaiBuddhistYear - 543; // Convert to Gregorian year
        var gregorianDateString =
            thaiBuddhistParts[0] +
            "/" +
            thaiBuddhistParts[1] +
            "/" +
            gregorianYear;
        var birthDate = new Date(gregorianDateString);
        var now = new Date();

        var years = now.getFullYear() - birthDate.getFullYear();
        var months = now.getMonth() - birthDate.getMonth();
        var days = now.getDate() - birthDate.getDate();

        if (months < 0 || (months === 0 && days < 0)) {
            years--;
            if (months < 0) {
                months += 12;
            }
            if (days < 0) {
                var monthEnd = new Date(
                    now.getFullYear(),
                    now.getMonth() - 1,
                    0
                ).getDate();
                days = monthEnd - birthDate.getDate() + now.getDate();
                months--;
            }
        }
        return {
            years: years,
            months: months,
            days: days,
        };
    };

    $.fn.setError = function (msg, reset = "") {
        Swal.fire({
            icon: "warning",
            title: $("#alert").val(),
            text: msg,
            confirmButtonText: $("#ok").val(),
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-active-light",
            },
        }).then(() => {
            if (reset != "") {
                $(`[name=${reset}]`).val("");
                $(`[name=${reset}]`).focus();
            }
        });
    };

    $.fn.getDate = (textlang) => {
        const today = new Date();
        let year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, "0");
        const day = today.getDate().toString().padStart(2, "0");

        if (textlang == "th") {
            year += 543;
        }
        return { year, month, day };
    };

    $.fn.get_item_type = (type) => {
        let name = "";
        if (type == 1) {
            name = "สินค้าและยา";
        } else if (type == 2) {
            name = "คอร์สและทรีทเมนท์";
        } else if (type == 3) {
            name = "แล็บ";
        } else if (type == 4) {
            name = "หัตถการและศัลยกรรม";
        } else if (type == 5) {
            name = "บริการและการรักษา";
        } else if (type == 6) {
            name = "โปรโมชั่น";
        } else if (type == 7) {
            name = "บัตรแทนเงินสด";
        } else if (type == 8) {
            name = "ชุดสินค้าและยา";
        } else {
            name = "";
        }

        return name;
    };

    $.fn.number_format = (number, decimals, decimalPoint, thousandsSep) => {
        decimalPoint = decimalPoint || ".";
        thousandsSep = thousandsSep || ",";

        var parts = number.toFixed(decimals).toString().split(".");

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

        return parts.join(decimalPoint);
    };

    $.fn.thdatetime = (strDate, format = "datetime", lang = "th") => {
        if (strDate && strDate !== "-") {
            const dateObj = new Date(strDate);
            let year = dateObj.getFullYear();

            if (year >= 2300) {
                year -= 543;
            }

            const month = dateObj.getMonth() + 1;
            const day = dateObj.getDate();
            const hour = dateObj.getHours();
            const minute = dateObj.getMinutes();

            let strYear = year;
            let strMonthCut = [
                "",
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ];

            if (lang === "th") {
                strYear = year + 543;
                strMonthCut = [
                    "",
                    "ม.ค.",
                    "ก.พ.",
                    "มี.ค.",
                    "เม.ย.",
                    "พ.ค.",
                    "มิ.ย.",
                    "ก.ค.",
                    "ส.ค.",
                    "ก.ย.",
                    "ต.ค.",
                    "พ.ย.",
                    "ธ.ค.",
                ];
            }

            const strMonthThai = strMonthCut[month];

            if (format === "datetime") {
                return `${day} ${strMonthThai} , ${hour}:${minute}`;
            } else if (format === "date") {
                return `${day} ${strMonthThai} ${strYear}`;
            } else {
                return false;
            }
        } else {
            return strDate;
        }
    };

    $(document).on("change", ".bmi", function (e) {
        const bmi = $(this).data("bmi");
        const element = $(`[data-bmi="${bmi}"]`);
        let weight = 0;
        let height = 0;
        let bmi_avg = 0;
        let bmi_elem;
        $(element).each(function (index, elem) {
            const name = $(elem).attr("name");
            if (name == "visit_weight") {
                weight = $(elem).val();
            } else if (name == "visit_height") {
                height = $(elem).val();
            } else if (name == "bmi") {
                bmi_elem = elem;
            }
        });

        bmi_avg = (weight / (height / 100) ** 2).toFixed(2);
        $(bmi_elem).val(bmi_avg);
    });

    $(document).on("input", '[data-input="number"]', function (e) {
        this.value = this.value.replace(/[^0-9\d]/g, "");
    });

    $.fn.set_token_csrf = async () => {
        await $.ajax({
            type: "GET",
            url: base_url + $("#textlang").val() + "/component/get_token",
            data: {},
            dataType: "JSON",
            success: function (res) {
                $(".csrf-page").val(res.token);
            },
        });

        return $(".csrf-page").val();
    };

    if (typeof jQuery.fn.dataTableExt !== "object") {
        jQuery.fn.dataTableExt = {};
    }

    if (typeof jQuery.fn.dataTableExt.oSort !== "object") {
        jQuery.fn.dataTableExt.oSort = {};
    }
    if ($("#textlang").val() == "th") {
        // สำหรับ sort date ที่แปลง format ไทยหรืออังกฤษ
        // type: "date-dd-mmm-yyyy",
        if (jQuery.fn.dataTableExt.oSort) {
            jQuery.extend(jQuery.fn.dataTableExt.oSort, {
                "date-dd-mmm-yyyy-pre": function (a) {
                    var dateParts = a.split(" ");
                    var day = parseInt(dateParts[0], 10);
                    var monthNames = [
                        "ม.ค.",
                        "ก.พ.",
                        "มี.ค.",
                        "เม.ย.",
                        "พ.ค.",
                        "มิ.ย.",
                        "ก.ค.",
                        "ส.ค.",
                        "ก.ย.",
                        "ต.ค.",
                        "พ.ย.",
                        "ธ.ค.",
                    ];
                    var month = monthNames.indexOf(dateParts[1]) + 1;
                    var year = parseInt(dateParts[2], 10);
                    return new Date(year, month - 1, day);
                },

                "date-dd-mmm-yyyy-asc": function (a, b) {
                    return a < b ? -1 : a > b ? 1 : 0;
                },

                "date-dd-mmm-yyyy-desc": function (a, b) {
                    return a < b ? 1 : a > b ? -1 : 0;
                },
            });
        }
    } else {
        if (jQuery.fn.dataTableExt.oSort) {
            jQuery.extend(jQuery.fn.dataTableExt.oSort, {
                "date-dd-mmm-yyyy-pre": function (a) {
                    return moment(a, "D MMM YYYY").unix();
                },

                "date-dd-mmm-yyyy-asc": function (a, b) {
                    return a < b ? -1 : a > b ? 1 : 0;
                },

                "date-dd-mmm-yyyy-desc": function (a, b) {
                    return a < b ? 1 : a > b ? -1 : 0;
                },
            });
        }
    }

    $.fn.sanitizeInput = (inputValue) => {
        var num = inputValue.replace(/,/g, "");
        num = num.replace(/[^0-9\.]/g, "");
        var hasPoint = false;
        var sanitized = "";
        for (var i = 0; i < num.length; i++) {
            if (num[i] === ".") {
                if (!hasPoint) {
                    hasPoint = true;
                    sanitized += num[i];
                }
            } else {
                sanitized += num[i];
            }
        }
        var parts = sanitized.split(".");
        if (parts.length === 1) {
            parts.push("00");
        } else if (parts[1].length > 2) {
            parts[1] = parts[1].slice(0, 2);
        }
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    };

    $(document).on("change", '[data-number-format="true"]', function (e) {
        this.value = $.fn.sanitizeInput(this.value);
    });

    $.fn.removeComma = (inputValue) => {
        return inputValue.replace(/,/g, "");
    };
    $.fn.toSeYear = function () {
        let oldVal = $(this).val();
        let newVal = oldVal;
        if (oldVal != "") {
            let splited = oldVal.split("/");
            if (splited.length == 3) {
                splited[2] = parseInt(splited[2]) - 543;
                newVal = splited.join("/");
            }
        }
        return newVal;
    };
    $.fn.toBeYear = function () {
        let oldVal = $(this).val();
        let newVal = oldVal;
        if (oldVal != "") {
            let splited = oldVal.split("/");
            if (splited.length == 3) {
                splited[2] = parseInt(splited[2]) + 543;
                newVal = splited.join("/");
            }
        }
        return newVal;
    };
    $.fn.generatePassword = function (length) {
        const charset =
            "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        return password;
    };
    $.fn.formatNumber = function (amount) {
        // แปลงตัวเลขให้มีทศนิยม 2 ตำแหน่ง
        const numberWithDecimal = parseFloat(amount).toFixed(2);
        // แยกทศนิยมและจำนวนเต็ม
        const [integerPart, decimalPart] = numberWithDecimal.split(".");
        // เพิ่มเครื่องหมาย ',' คั่นจำนวนเต็ม
        const formattedIntegerPart = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ","
        );
        // รวมกลับเข้าด้วยกัน
        const formattedNumber = formattedIntegerPart + "." + decimalPart;
        return formattedNumber;
    };
    $.fn.daysToYearsMonths = function (days) {
        // 1 ปี = 365.25 วัน (ปีอธิกสุรทิน)
        const daysInYear = 365.25;

        // 1 เดือน = 30.44 วัน (ค่าประมาณ)
        const daysInMonth = 30.44;

        // แปลงจำนวนวันเป็นจำนวนปี
        const years = Math.floor(days / daysInYear);

        // คำนวณจำนวนวันที่เหลือหลังจากลบจำนวนปี
        const remainingDaysAfterYears = days % daysInYear;

        // แปลงจำนวนวันที่เหลือเป็นจำนวนเดือน
        const months = Math.floor(remainingDaysAfterYears / daysInMonth);

        // คำนวณจำนวนวันที่เหลือหลังจากลบจำนวนเดือน
        const remainingDays = Math.floor(remainingDaysAfterYears % daysInMonth);

        // สร้างออบเจ็กต์ที่เก็บผลลัพธ์
        const result = {
            years: years,
            months: months,
            days: remainingDays,
        };

        return result;
    };
    $.fn.numberFormat = function (value, digits = 2) {
        value = parseFloat(value);
        if (!isNaN(value)) {
            value = value.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })
        }
        return value;
    }
});

function convertBuddhistDate(date, format = "ll") {
    date = moment(date, "YYYY-MM-DD");
    const buddhistDate = date
        .clone()
        .add(543, "years")
        .locale("th")
        .format(format);
    return buddhistDate;
}
function dateFromLang(date, format = "YYYY-MM-DD") {
    const textLang = $("#textLang").val();
    if (textLang === undefined) {
        console.error("text lange not defined");
        return "Invalid date";
    }
    if (textLang == "th") {
        return convertBuddhistDate(date, format);
    } else {
        return moment(date).format(format);
    }
}
function canPermission(permissionName) {
    var permissionValues = $("#permissions").val();
    if (permissionValues === undefined) {
        console.error("Permission value not defined");
        return false;
    }
    const permissions = JSON.parse(permissionValues);
    if (permissions[permissionName] === undefined) {
        return false;
    }
    if (permissions[permissionName] == "Y") {
        return true;
    }
    return false;
}


